export default __webpack_public_path__ + "static/media/maestro.31971693.svg";